import { Reveal } from "../../lib/reveal";
import { METHOD_STEPS } from "../../data/content";

const Method = () => (
  <section data-testid="method-section" className="bg-bati-mist py-16 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="mb-10 max-w-2xl lg:mb-16">
        <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
          <span className="h-px w-10 bg-bati-sky" /> Notre méthode
        </p>
        <h2 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink sm:text-5xl">
          Un interlocuteur unique<br />pour votre projet
        </h2>
      </Reveal>

      <div className="grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 lg:gap-y-14">
        {METHOD_STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.08}>
            <div className="border-t-2 border-bati-ink pt-6" data-testid={`method-step-${step.num}`}>
              <span className="font-display text-6xl font-extrabold tracking-tight text-bati-sky/90">{step.num}</span>
              <h3 className="mt-4 font-display text-xl font-bold text-bati-ink">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-bati-ink/60">{step.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Method;
